import React, { Fragment } from 'react';

const HeaderBackground = () => (
  <Fragment>
    <div className="header-left" />
    <div className="header-right" />
  </Fragment>
);

export default HeaderBackground;
